import React, { Fragment, useState, useEffect, useRef } from 'react'
import TopEnterTips from '../Components/TopEnterTips'
import Process from '../../Components/Process'
import Form from '../../Components/Form'
import LightMobileCall from "@kugou/light-mobilecall";
import './index.scss'
import config from './config'
import Button from '../../Components/Button'
import Dialog from '../../Components/Dialog'
import FixBottomBtn from '../Components/FixBottomBtn'
import FollowTips from '../Components/FollowTips'
import TencentDialog from '../Components/BindTencentDialog'
import BindResultDialog from '../Components/BindResultDialog'
import HasBeenBindDialog from '../Components/HasBeenBindDialog'
import ConfirmDialog from '../Components/ConfirmDialog'
import AppealDialog from '../Components/AppealDialog'
import FaceRecognition from'../FaceRecognition'
import { getBaseConfig } from '../../Base'
import history from '../../History'
import e from '../../Utils/Event'
import {getQueryString, replaceHttpsImg, textSub, refreshPage, formatDate, openKg, openKf} from '../../Utils/Utils'

export default function Enter(props) {
  //判断方式：
  //1: 前端入口缓存（新入驻、认领）
  //2: 3.3.22 校园信息查询接口（审核中、已入驻）
  const [collegeEnter, setCollegeEnter] = useState(false)//判断是否为校园入驻
  //链接参数
  const [params, setParams] = useState(null)

  //对应70、71、72状态70=词曲作者已入驻待补充歌手信息 ，71=词曲作者已入驻待补充歌手信息提交审核中 ，72=词曲作者已入驻待补充歌手信息提交审核拒绝
  //只需填写第一页，无需填写实名信息，无绑定
  const [settledLibrettist, setSettledLibrettist] = useState(false)
  //未通过页面的按钮文案
  const [mbtnText, setMbtnText] = useState("去修改")
  //实名自动填写身份证及姓名
  const [autoFillRealInfo, setAutoFillRealInfo] = useState(false)
  //人脸识别回来flag, 0失败 1成功 2初始，未人脸
  const [faceBackFlag, setFaceBackFlag] = useState(2);
  const [canInput, setCanInput] = useState(true);
  //实名认证文案
  const [realAuthTip, setRealAuthTip] = useState({
    type: 'normal',
    text: '进入人脸认证'
  })
  const [showSelectTip, setShowSelectTip] = useState(false)
  const [selectType, setSelectType] = useState(0)
  //人脸识别状态
  const [realAuth, setRealAuth] = useState(0)
  const [hasImg, setHasImg] = useState(0)
  const [jumpUrl, setJumpUrl] = useState('')
  const [openRecognite, setOpenRecognite] = useState('')
  //实名认证回来
  const [faceAuthBack, setFaceAuthBack] = useState('')
  const [btnFn, setBtnFn] = useState(null)
  const [tipsContent, setTipsContent] = useState('')
  const [hideClose, setHideClose] = useState(false)

  //判断原唱还是翻唱；0默认值，没记录 1原创 2翻唱 3词曲， 0前端表现和1一样，只是后端区分
  const [original, setOriginal] = useState(1)//默认显示上传作品按钮

  //原创
  const [toUploadSongDialog, setToUploadSongDialog] = useState(false)
  const [hasUploadSongDialog, setHasUploadSongDialog] = useState(false)

  //翻唱
  const [toCoverUploadSongDialog, setToCoverUploadSongDialog] = useState(false)
  const [hasCoverUploadSongDialog, setHasCoverUploadSongDialog] = useState(false)

  //作品不通过原因
  const [workNoPassReason, setWorkNoPassReason] = useState('')

  //人脸识别防多次点击产生多次请求
  const [faceClickFlag, setFaceClickFlag] = useState(false)

  const [dialogFromUrl, setDialogFromUrl] = useState(false)
  const [dialogFromUrlCon, setDialogFromUrlCon] = useState('')
  const [ title, setTitle ] = useState( '提示' )
  const [ left, setLeft ] = useState( false )//设置文案靠左

  //透传所有url参数
  let curUrl = "https://h5.kugou.com/apps/musician-enter/build/"
  function showTips(word, btnFn, hideClose) {
    setTipsContent(word)
    let fn = [{ text: '知道了', fn: () => {setShowTipsDialog(false);btnFn&&btnFn();} }];
    setBtnFn(btnFn || fn)
    setShowTipsDialog(true)
    setHideClose(hideClose)
  }
  async function getFaceAuth_2 () {
    var data = await window.$req('get_face_status')
    //console.log('data_', data)
    return data
  }

  useEffect(() => {
    let _param = {
      faceAuthBack: true,
      name: realName,
      num: credentialNum
    }
    let url = encodeURIComponent(curUrl+'?FaceAuBack='+window.encodeURIComponent(JSON.stringify(_param)));
    setJumpUrl(url);
  }, [realName, credentialNum])

  useEffect(() => {
    //校园入驻
    if( localStorage.getItem(`enter-musician-${window.$userInfo.userid}`) == '4' || localStorage.getItem(`enter-musician-${window.$userInfo.userid}`) == '5' ){
      setCollegeEnter(true)
    }else{
      setCollegeEnter(false)
    }
    let _href = window.location.href.indexOf('FaceAuBack') > -1 ? window.decodeURIComponent(window.location.href) : ''
    let temp = _href.slice(_href.indexOf('FaceAuBack') + 'FaceAuBack'.length + 1, _href.indexOf('&')).replace('"{','{').replace('}"','}')
    let info = temp ? JSON.parse(temp) : null
    if (info) {
      let realInfo = info
      if(realInfo.faceAuthBack){
        e.emit('loading', true)
        // 左上角退出
        LightMobileCall.mobileCall(710, { type: 0});
        setFaceAuthBack(realInfo.faceAuthBack)
        console.log('faceAuthBack');
      }
    }
    //安卓弹出键盘设置（270）http://doc.kugou.net/showdoc-master/web/#/5?page_id=578
    LightMobileCall.mobileCall(270, {type: 1});
    //去上传歌曲标识初始化
    localStorage.removeItem(`to-upload-song-${window.$userInfo.userid}`)

    //人脸识别重新返回页面
    async function faceAuthBackFn(){
      let storage = localStorage.getItem("kg_faceid")
      console.log(storage,'storage');
      if(storage != null && storage){
        let facedata = await getFaceAuth_2()
        setHasImg(facedata.has_img)
        setRealAuth(facedata.real_auth)
        //接口的hasimg有延时，从人脸识别回来realauth==2即为成功
        if(facedata.real_auth == 2/*  && facedata.has_img == 1 */) {
          setAuthType(0)
          setRealAuthTip({
            type: 'normal',
            text: '人脸识别成功'
          })
          setShowSelectTip(false)
          setShowIDCard(false)
          setHumanFaceFlag(true)
          setFaceBackFlag(1)
          setCanInput(false)
          console.log('人脸识别成功');
        } else {
          window.$Msg(window.decodeURIComponent(JSON.parse(localStorage.getItem("kg_faceid")).errorMsg), 3000);
          setRealAuthTip({
            type: 'normal',
            text: '认证失败'
          });
          setShowSelectTip(true)
          setAuthType(1)
          setFaceBackFlag(0)
          console.log('认证失败');
        }
        //sendAudit();
        localStorage.removeItem("kg_faceid");
      }
    }

    //重新返回页面回调
    LightMobileCall.KgWebMobileCall("KgWebMobileCall.pageStatusNew", async function(res){
      res = typeof(res) == 'string' ? JSON.parse(res) : res;
      console.log("KgWebMobileCall.pageStatusNew", res);
      if(res.status == 3){
        //上传歌曲重新返回页面
        if( localStorage.getItem(`to-upload-song-${window.$userInfo.userid}`) == 'go-wx-minigram' ){
          console.log('上传歌曲重新返回页面');
          refreshPage()
          return;
        }
        //人脸识别重新返回页面
        faceAuthBackFn()
      }
    });

    e.on("face_auth_back", ()=>{
      console.log('实名结果回来 入驻页');
      //人脸识别重新返回页面
      faceAuthBackFn();
    })

    let coversongtip = getQueryString('coversongtip')
    let uploadSongTip = getQueryString('uploadSongTip')
    if((coversongtip || uploadSongTip) && !window.TipFromUrl){
      window.TipFromUrl = true;
      let con;
      if(coversongtip){
        con = `<p>1.请先入驻为<em>酷狗音乐人</em>；</p>
        <p>2.电脑端登录酷狗音乐开放平台（<em>musician.kugou.com</em>）点击“<em>翻唱福利</em>”，上传正版化翻唱歌曲，即可获得<em>10%</em>歌曲收益。</p>`
        setLeft(true)
        setTitle('上传翻唱')
      }else{
        con = '入驻成为酷狗音乐人后，即可上传作品获得版权分成哦'
      }
      setDialogFromUrl(true)
      setDialogFromUrlCon(con)
    }
    if(getQueryString( 'tleft' )){
      setLeft(true)
    }
    let manageTip = getQueryString( 'manageTip' );
    if ( manageTip && !window.TipFromUrl ){
      window.TipFromUrl = true;
      let con = '<p>请先入驻成为音乐人，入驻后即可管理自己的作品~</p>';
      setDialogFromUrlCon( con )
      setDialogFromUrl( true )
    }
    let singTip = getQueryString( 'singTip' );
    if ( singTip && !window.TipFromUrl ){
      window.TipFromUrl = true;
      let con = parseInt(singTip) == 1 ? '<p>请先入驻成为酷狗音乐人<br/>即可在5sing交流平台交易词曲噢~</p>':'<p>请先入驻成为酷狗音乐人<br/>就可以在5sing交流平台交易词曲、接单做任务啦~</p>'
      setDialogFromUrlCon( con )
      setDialogFromUrl( true )
    }
    let cqTip = getQueryString( 'cqTip' );
    if ( cqTip && !window.TipFromUrl ){
      window.TipFromUrl = true;
      let con = `<p>1.入驻酷狗音乐人-<em>词曲作者</em>；</p>
      <p>2.电脑端登录酷狗音乐开放平台（<em>musician.kugou.com</em>）点击<em>“出售词曲”，</em>上传未发行的词曲demo（不会对外发行），出售成功可获<em>100%</em>成交价；</p>
      <p>3.审核通过的作品还将进行综合评选，择优收录进<em>伯乐计划首张专辑</em>！</p>`
      setTitle('出售词曲')
      setDialogFromUrl( true )
      setDialogFromUrlCon( con )
      setLeft(true)
    }
    let claimSongTip = getQueryString( 'claimSongTip' );
    if ( claimSongTip && !window.TipFromUrl ){
      window.TipFromUrl = true;
      let con = `<p>1.请先入驻为<em>酷狗音乐人</em>；</p>
      <p>2.电脑端登录酷狗音乐开放平台（<em>musician.kugou.com</em>）点击“<em>认领词曲</em>”，最高可获<em>16%</em>版税收益；</p>
      <p>3.审核通过后，可在开放平台<em>【收入概览】</em>看到您的词曲收益。</p>`
      setTitle('认领词曲')
      setDialogFromUrl( true )
      setDialogFromUrlCon( con )
      setLeft(true)
    }
    let goSettleTip = getQueryString( 'goSettleTip' );
    if ( goSettleTip && !window.TipFromUrl ){
      window.TipFromUrl = true;
      let con = `<p>1.请先入驻<em>酷狗音乐人</em>；</p>
      <p>2.签约独家单曲，年总收入<em>20万元</em>以内，平台不分成<em>100%</em>都归你；</p>
      <p>3.签约独家音乐人，年总收入<em>100万元</em>以内，平台不分成<em>100%</em>都归你。</p>`
      setTitle('提示')
      setDialogFromUrl( true )
      setDialogFromUrlCon( con )
      setLeft(true)
    }
    //弹窗从url获取的提示
    let enterTip = getQueryString('enterTip')
    let enterTipCon = getQueryString('enterTipCon')
    let bothTip = getQueryString('bothTip')
    let bothTipCon = getQueryString('bothTipCon')
    if((enterTip && enterTipCon) || (bothTip && bothTipCon)){
      if( !window.TipFromUrl ){
        //replace(/%/g, '%25') : 解决浏览器在对“%”执行decodeURIComponent时报错
        let con = enterTipCon ? window.decodeURIComponent(enterTipCon.replace(/%/g, '%25')) : window.decodeURIComponent(bothTipCon.replace(/%/g, '%25'))
        con = con.replace('音乐人网址','https://musician.kugou.com/<br/>')
        window.TipFromUrl = true;
        setDialogFromUrl(true)
        setDialogFromUrlCon(con)
      }
    }
  }, [])

  //用户状态
  // const [userStatus, setUserStatus] = useState(10)
  const [formatUserStatus, setFormatUserStatus] = useState('')
  const [gotConfig, setGotConfig] = useState({})
  const [activeIndex, changeActiveIndex] = useState(0)//0:歌手信息，1：校园信息，2：实名认证
  const [platform, setPlatform] = useState(1)
  //const [ifAdult, setifAdult] = useState(false)
  //是否修改表单
  const [ifModify, setIfModify] = useState(false)

  //可控选择器的国籍选项
  // const [countryOptions, setCountryOptions] = useState({})

  //如果是不通过的，显示不通过原因
  const [noPassReason, setNoPassReason] = useState('')
  //学生信息不通过原因
  const [stuNoPassReason, setStuNoPassReason] = useState('')

  //提示弹窗
  const [showTipsDialog, setShowTipsDialog] = useState(false)
  const [otherGetDialog, setOtherGetDialog] = useState(false)
  const [ifOtherGet, setIfOtherGet] = useState(false)
  const [showIdCardTipsDialog, setShowIdCardTipsDialog] = useState(false)
  const [showInviteCodeTipsDialog, setShowInviteCodeTipsDialog] = useState(false)

  // 表单相关
  //认领歌手的
  const [claimSingerId, setClaimSingerId] = useState('')
  //p1
  const [pic, setPic] = useState('')
  const [name, setName] = useState('')
  const [identity, setIdentity] = useState('')
  const [type, setType] = useState('')
  const [area, setArea] = useState('')
  const [genre, setGenre] = useState('')
  const [introduce, setIntroduce] = useState('')
  //p2
  const [credentialType, setCredentialType] = useState(0)//设置默认身份证
  //0人脸识别 1身份证 2非人脸非身份证
  const [authType, setAuthType] = useState(0)//设置认证方式
  const [authTypeHidden, setAuthTypeHidden] = useState(false)//设置认证方式隐藏
  const [credentialFrontPic, setCredentialFrontPic] = useState('')
  const [credentialBackPic, setCredentialBackPic] = useState('')
  const [credentialHandPic, setCredentialHandPic] = useState('')
  const [credentialNum, setCredentialNum] = useState('')
  const [country, setCountry] = useState(1)//默认中国大陆
  const [realName, setRealName] = useState('')
  const [phone, setPhone] = useState('')
  const [verifyCode, setVerifyCode] = useState('')
  const [mail, setMail] = useState('')
  const [inviteCode, setInviteCode] = useState('')

  //学生信息
  const [educationLevel, setEducationducationLevel] = useState('')
  const [schoolName, setSchoolName] = useState('')
  const [schoolType, setSchoolType] = useState('')
  const [graduationTime, setGraduationTime] = useState('')
  const [cardCover, setCardCover] = useState('')
  const [cardContentPage, setCardContentPage] = useState('')
  const [cardRegisterPage, setCardRegisterPage] = useState('')

  // 绑定结果弹窗
  const [bindInitPhone, setBindInitPhone] = useState('')
  const [bindSubTitle, setBindSubTitle] = useState('')
  const [checkNumInfo, setCheckNumInfo] = useState('')
  const [bindDialogVisible, setBindDialogVisible] = useState(false)
  const [resultDialogVisible, setResultDialogVisible] = useState(false)
  const [resultStatus, setResultStatus] = useState(2)

  //提交错误的一些弹窗
  const [beenBindDialogVisible, setBeenBindDialogVisible] = useState(false)
  //身份证号被限制的标记
  const [ifCardBind, setIfCardBind] = useState(false)
  const [cardBindPhone, setCardBindPhone] = useState('')
  const [appealDialogVisible, setAppealDialogVisible] = useState(false)
  const [showIDCard, setShowIDCard] = useState(false)
  const [humanFaceFlag, setHumanFaceFlag] = useState(false)
  const [dynamicOps, setDynamicOps] = useState({
    authOps: [
      { value: 0, label: '人脸识别' },
      { value: 1, label: '上传手持身份证照片、身份证正反面' }
    ]
  });

  //认证失败弹窗相关
  const [showAuthFailDialog, setShowAuthFailDialog] = useState(false)
  const [authTip, setAuthTip] = useState('')
  const [authBtn, setAuthBtn] = useState({
    1: true,
    2: true,
    3: false,
    4: false
  })

  //结果传参
  const [info, setInfo] = useState({})
  //同意协议
  const [agree, setAgree] = useState(false)
  const containRef = useRef(null)
  const bottomTip = useRef(null)
  const pageBottom = useRef(null)

  // 对应的表单状态展示
  const formStatusGroup = {
    10: 'workInAudit', 12: 'failGo',
    13: 'workInAudit', 14: 'failGo', 16: 'noWork', 17: 'fail',
    18: 'workInAudit', 19: 'failWork', 20: 'getInAudit', 22: 'getFail',
    23: 'getInAudit', 24: 'getFail', 25: 'getError',
    //70=词曲作者已入驻待补充歌手信息 ，71=词曲作者已入驻待补充歌手信息提交审核中 ，72=词曲作者已入驻待补充歌手信息提交审核拒绝
    70: 'cqSupply', 71: 'cqInAudit', 72: 'cqFail',

    //自定义的status
    900: 'delete', 901: 'black'
  }

  function ifAdult() {
    //console.log('credentialNum', credentialNum)
    if(credentialNum.length == 18) {
      const birthYear = credentialNum.substring(6,10);
      const birthMonthDate = credentialNum.substring(10,14);
      const nowYear = new Date().getFullYear();
      const nowMonth = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1)
      const nowDate = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
      const nowMonthDate = String(nowMonth) + String(nowDate)
      if(nowYear - birthYear > 18) return true
      else if(nowYear - birthYear == 18) {
        if(Number(nowMonthDate) - Number(birthMonthDate) > 0) return true
        else return false
      } else return false
    } else if (credentialType != 4) {
      return true
    } else return false
  }

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) { return pair[1]; }
    }
    return false;
  }

  //获取url的邀请码
  function getInviteCode() {
    let invite = getQueryVariable('code')
    if (invite) { setInviteCode(invite) }
  }

  //测试
  // useEffect(() => {
  //   setCardBindPhone('+86123')
  //   setIfCardBind(true)
  //   controlCardBind()
  // }, [])

  //打开提示身份证被绑定了等的窗口
  function controlCardBind() {
    if (cardBindPhone) {
      if (~cardBindPhone.indexOf('+86')) {
        setBindSubTitle(`您的证件号码已用（${cardBindPhone}）完成注册，直接验证绑定即可`)
        setBindInitPhone('')
        setBindDialogVisible(true)
      } else {
        setBindSubTitle(`您的证件号码已用（${cardBindPhone}）完成注册，现暂不支持国外手机号绑定`)
        setBindInitPhone('')
        setBindDialogVisible(true)
      }
    } else if (ifCardBind) {
      setBindInitPhone('')
      setBindSubTitle(checkNumInfo || `您的证件号码已经被绑定其他账号`)
      setBindDialogVisible(true)
    }
  }

  function showIDCardEnter() {
    setShowIDCard(true)
    setShowSelectTip(true)
    setAuthType(1)
    setFaceBackFlag(0)
    setCanInput(false)
  }

  useEffect(() => {
    setAuthType(2)
    setCanInput(true)
    //户口簿
    if(credentialType == 4) {
      setSelectType(1)
    } else {
      setSelectType(0)
    }
    //身份证、户口簿
    if(credentialType == 0 || credentialType == 4) {
      setCountry(1)
    }
    //身份证
    if( credentialType == 0 ){
      setAuthTypeHidden(false)
      setAuthType(0)
      if (faceBackFlag == 0) {
        setAuthType(1)
      }
    } else{
      setAutoFillRealInfo(false)//非自动填写
      setCredentialHandPic('')
      setCredentialFrontPic('')
      setCredentialBackPic('')
      // setCredentialNum('')
      // setRealName('')
      setAuthTypeHidden(true)
      setShowSelectTip(false)

      //人脸识别失败才显示
      if(credentialType == 4 && faceBackFlag == 0) {
        setShowSelectTip(true)
      } 
    }
  }, [credentialType])

  // //认证方式修改，清空已填
  // useEffect(() => {
  //   setCredentialHandPic('')
  //   setCredentialFrontPic('')
  //   setCredentialBackPic('')
  //   setCredentialNum('')
  //   setRealName('')
  // }, [authType])

  useEffect(() => {
    controlCardBind()
  }, [ifCardBind])

  //humanFaceFlag: 不传身份证、人脸识别时为true
  useEffect(() => {
    //上传身份证、身份证
    setShowIDCard(authType == 1 && credentialType == 0)
    //调试 setShowIDCard(true)
    //人脸识别、身份证
    setHumanFaceFlag(authType == 0 && credentialType == 0 ?  true : false)
  }, [authType, credentialType])

  //人脸识别发生变化，切换提交方式
  useEffect(() => {
    //console.log('realAuth',realAuth)
    //console.log('hasImg',hasImg)
    if(realAuth == 2 && hasImg == 0) {
      setAuthType(1)
      //上传身份证、身份证
      //setShowIDCard(true)
    } else {
      setAuthType(0)
      //setShowIDCard(false)
    }
  }, [realAuth, hasImg])

  function localSaveForm(){
    sessionStorage.setItem('saveForm', JSON.stringify({
      realName,
      phone,
      mail,
      country,
      credentialType,
      credentialNum,
      credentialFrontPic,
      credentialBackPic,
      credentialHandPic,
      name,
      pic,
      type,
      area,
      identity,
      genre,
      introduce,
      educationLevel,
      schoolName,
      schoolType,
      graduationTime,
      cardCover,
      cardContentPage,
      cardRegisterPage,
    }))
  }

  function toCheckAgreeDetail(e) {
    e.stopPropagation();
    localSaveForm()
    history.go('/agreement')
  }

  let fields1 = config({
    'ifModify': ifModify,
    'claimSingerId': claimSingerId,

    'pic': pic,
    'name': name,
    'identity': identity,
    'type': type,
    'area': area,
    'genre': genre,
    'introduce': introduce,

    'setPic': setPic,
    'setName': setName,
    'setIdentity': setIdentity,
    'setType': setType,
    'setArea': setArea,
    'setGenre': setGenre,
    'setIntroduce': setIntroduce
  }, props).fields1

  let fields2 = config({
    'ifModify': ifModify,

    'educationLevel': educationLevel,
    'schoolName': schoolName,
    'schoolType': schoolType,
    'graduationTime': graduationTime,
    'cardCover': cardCover,
    'cardContentPage': cardContentPage,
    'cardRegisterPage': cardRegisterPage,

    'setEducationducationLevel': setEducationducationLevel,
    'setSchoolName': setSchoolName,
    'setSchoolType': setSchoolType,
    'setGraduationTime': setGraduationTime,
    'setCardCover': setCardCover,
    'setCardContentPage': setCardContentPage,
    'setCardRegisterPage': setCardRegisterPage,
  }, props).fields2

  let fields3 = config({
    setCardBindPhone,
    setIfCardBind,
    setShowIdCardTipsDialog,
    setShowInviteCodeTipsDialog,

    'ifModify': ifModify,
    'inviteCodeDisabled': !!getQueryVariable('code'),
    // 'countryOptions': countryOptions,
    // 'setCountryOptions': setCountryOptions,

    'credentialType': credentialType,
    'authType': authType,
    'credentialFrontPic': credentialFrontPic,
    'credentialBackPic': credentialBackPic,
    'credentialHandPic': credentialHandPic,
    'credentialNum': credentialNum,
    'country': country,
    'realName': realName,
    'phone': phone,
    'verifyCode': verifyCode,
    'byPhone': phone,
    'mail': mail,
    'inviteCode': inviteCode,

    'setCredentialType': setCredentialType,
    'setAuthType': setAuthType,
    'setCredentialFrontPic': setCredentialFrontPic,
    'setCredentialBackPic': setCredentialBackPic,
    'setCredentialHandPic': setCredentialHandPic,
    'setCredentialNum': setCredentialNum,
    'setCountry': setCountry,
    'setRealName': setRealName,
    'setPhone': setPhone,
    'setVerifyCode': setVerifyCode,
    'setMail': setMail,
    'setInviteCode': setInviteCode
  }, props, dynamicOps).fields3

  //字段检测
  function checkField() {
    if( credentialType == 4 && ifAdult() && !settledLibrettist ) {
      setShowAuthFailDialog(true)
      setAuthTip('户口簿仅适用于未满18岁的用户，您已满18岁，请使用身份证进行实名认证');
      setAuthBtn({
        1: false,
        2: false,
        3: false,
        4: true
      })
      return
    }
    const needMsgP1 = {
      pic: { key: pic, msg: '请上传歌手头像' },
      name: { key: name, msg: '请填写歌手名' },
      identity: { key: identity, msg: '请选择歌手身份' },
      type: { key: type, msg: '请选择性别' },
      area: { key: area, msg: '请选择地区' },
      genre: { key: genre, msg: '请选择流派风格' },
      introduce: { key: introduce, msg: '请填写简介' },
    }

    if (platform === 4) {
      delete needMsgP1.introduce
    }

    const needMsgP2 = {
      credentialType: { key: credentialType, msg: '请选择证件类型' },
      credentialHandPic: { key: credentialHandPic, msg: credentialType == 4 ? '请上传户口簿首页' : '请上传手持人像面' },
      credentialFrontPic: { key: credentialFrontPic, msg:  credentialType == 4 ? '请上传户口簿个人页' : '请上传人像面' },
      credentialBackPic: { key: credentialBackPic, msg: '请上传国徽面' },
      credentialNum: { key: credentialNum, msg: '请填写证件号码' },
      country: { key: country, msg: '请选择国籍' },
      realName: { key: realName, msg: '请填写真实姓名' },
      phone: { key: phone, msg: '请填写手机' },
      /* mail: { key: mail, msg: '请填写邮箱' }, */
    }

    const needMsgP3 = {
      educationLevel: { key: educationLevel, msg: '请选择教育水平' },
      schoolType: { key: schoolType, msg: '请选择就读院校地区' },
      schoolName: { key: schoolName, msg: '请选择就读院校' },
      graduationTime: { key: graduationTime, msg: '请选择毕业时间' },
      educationLevel: { key: educationLevel, msg: '请选择教育水平' },
      //cardCover: { key: cardCover, msg: '请上传学生证正面' },
      //cardContentPage: { key: cardContentPage, msg: '请上传学生证信息页' },
      //cardRegisterPage: { key: cardRegisterPage, msg: '请上传学生证注册登记页' },
    }

    // return true;
    let $t = window.$Msg
    if (activeIndex === 0) {
      //p1表单页

      // if (~[pic, name, type, area, genre, introduce].indexOf('')) {
      //   $t('请先补充完整信息')
      //   return false;
      // }

      let erMsg1 = ''
      for (let k in needMsgP1) {
        if (needMsgP1[k].key === '') {
          erMsg1 += '\n' + needMsgP1[k].msg
        }
      }
      if (erMsg1) {
        $t(erMsg1.slice(1))
        return false;
      }

      let introLen = (introduce || '').length
      if ((introLen < 10 || introLen > 2000) && platform !== 4) {
        $t('个人简介请控制在10-2000字')
        return false;
      }

      if (name.length > 60) {
        $t('歌手名请控制在60字内')
        return false;
      }

      if (!agree) {
        $t('请先阅读协议并同意')
        containRef && containRef.current &&(containRef.current.scrollTop = containRef.current.scrollHeight - containRef.current.offsetHeight)
        return false;
      }
    } else if (activeIndex === 2) {
      //p2表单页
      // if (~[credentialType, credentialHandPic, credentialFrontPic,
      //   credentialNum, country, realName, phone, mail].indexOf('')) {
      //   $t('请先补充完整信息')
      //   return false;
      // }
      // if (credentialType === 0 && !credentialBackPic) {
      //   $t('请先补充完整信息')
      //   return false;
      // }

      let erMsg2 = ''
      for (let k in needMsgP2) {
        // 如果选择身份证
        if (credentialType === 0) {
          if (!showIDCard) {
            if (needMsgP2[k].key === '' && k !== 'credentialHandPic' && k !== 'credentialFrontPic' && k !== 'credentialBackPic') {
              erMsg2 += '\n' + needMsgP2[k].msg
            }
          } else {
            if (needMsgP2[k].key === '' && k !== 'credentialNum' && k !== 'realName') {
              erMsg2 += '\n' + needMsgP2[k].msg
            }
          }
         
        } else {
          if (needMsgP2[k].key === '' && k !== 'credentialBackPic') {
            erMsg2 += '\n' + needMsgP2[k].msg
          }
        }
      }

      if (credentialType === 0) {
        if (showIDCard && credentialFrontPic && (!credentialNum || !realName)) {
          erMsg2 += '\n人像面未识别身份证号码、姓名，请重新上传'
        }
      }

      if (erMsg2) {
        $t(erMsg2.slice(1))
        return false;
      }


      if (!ifModify && !window.$userStatus.hasOwnProperty('users')) {
        if (!verifyCode) {
          $t('请输入验证码')
          return false;
        }
        if (verifyCode.length !== 6) {
          $t('请输入6位验证码')
          return false;
        }
      }

      if (credentialNum.length > 100) {
        $t('证件号码请控制在100字内')
        return false;
      }

      if (realName.length > 60) {
        $t('真实姓名请控制在60字内')
        return false;
      }

      if (cardBindPhone) {
        controlCardBind()
        return false;
      }
    }else if(activeIndex === 1){
      let erMsg3 = ''
      for (let k in needMsgP3) {
        console.log(k, needMsgP3[k].key);
        if (needMsgP3[k].key === '') {
          erMsg3 += '\n' + needMsgP3[k].msg
        }
      }
      if (erMsg3) {
        $t(erMsg3.slice(1))
        return false;
      }
    }
    return true;
  }

  function openFaceAuth() {
    if(realAuth == 2 && hasImg == 1) return

    //延时操作，2S之后才能再点
    if(!faceClickFlag) {
      setFaceClickFlag(true)
      setTimeout(() => {
        setFaceClickFlag(false)
      }, 2000);
    } else {
      return
    }
    let _param = {
      faceAuthBack: true,
      name: realName,
      num: credentialNum
    }
    let url = encodeURIComponent(curUrl+'?FaceAuBack='+window.encodeURIComponent(JSON.stringify(_param)));
    setJumpUrl(url);
    setOpenRecognite(1+Math.random()*10)
  }

  //已入驻的词曲作者补充/修改资料
  function sendLibrettistAudit(){
    let data = {
      name,
      pic,
      type,
      area,
      identity,
      genre,
      introduce,
      platformAccountId: window.$userInfo.userid,
      platformIdType: 2
    }
    window.$req('cqSupplement', data).then(res => {
      e.emit('loading', false)
      window.$Msg('提交成功')
      window.$toResultTag = true
      window.$getUserStatus(({ status }) => {
        setFormatUserStatus(formStatusGroup[status])
        changeActiveIndex(3)
        LightMobileCall.mobileCall(710, { type: 0 })
        localStorage.removeItem('faceAuthPhoneFlag')
        localStorage.removeItem('claimSingerId')
      }, true)
    }).catch(rese => {
      e.emit('loading', false)
      if (rese.message) {
        let code = rese.code
        if (code === '040011') {
          setShowTipsDialog(true)
        } else {
          window.$Msg(rese.message)
        }
      }
    })
  }

  // 提交审核
  function sendAudit() {
    let data = {
      platformAccountId: window.$userInfo.userid,
      personInfo: {
        name: realName,
        phone: ~phone.indexOf('+86*') ? phone : '+86*' + phone,
        mail,
        country,
        credentialType,
        credentialNum,//humanFaceFlag：true的话，证件照图片的参数不能传值
        credentialFrontPic: !humanFaceFlag && credentialFrontPic ? (credentialFrontPic.match(/.+(noUserId\/)(.+?)\?.+/) ? credentialFrontPic.match(/.+(noUserId\/)(.+?)\?.+/)[2] :　credentialFrontPic): '',
        credentialBackPic: !humanFaceFlag && credentialBackPic ? (credentialBackPic.match(/.+(noUserId\/)(.+?)\?.+/) ? credentialBackPic.match(/.+(noUserId\/)(.+?)\?.+/)[2] :　credentialFrontPic): '',
        credentialHandPic: !humanFaceFlag && credentialHandPic ? (credentialHandPic.match(/.+(noUserId\/)(.+?)\?.+/) ? credentialHandPic.match(/.+(noUserId\/)(.+?)\?.+/)[2] :　credentialFrontPic): '',
        //没有认证过并且选择身份证 加人脸识别属性
        humanFaceFlag: humanFaceFlag
      },
      singerInfo: {
        name,
        pic,
        type,
        area,
        identity,
        genre,
        introduce
      }
    }
    if(collegeEnter){
      data = Object.assign(data, {
        studentInfo: {
          educationLevel,
          schoolType,
          schoolName,
          graduationTime,
          cardCover: cardCover ? (cardCover.match(/.+(noUserId\/)(.+?)\?.+/) ? cardCover.match(/.+(noUserId\/)(.+?)\?.+/)[2] :　cardCover): '',
          cardContentPage: cardContentPage ? (cardContentPage.match(/.+(noUserId\/)(.+?)\?.+/) ? cardContentPage.match(/.+(noUserId\/)(.+?)\?.+/)[2] :　cardContentPage): '',
          cardRegisterPage: cardRegisterPage ? (cardRegisterPage.match(/.+(noUserId\/)(.+?)\?.+/) ? cardRegisterPage.match(/.+(noUserId\/)(.+?)\?.+/)[2] :　cardRegisterPage): '',
        }
      })
    }
    //兼容新上传图片接口数据

    if (inviteCode) {
      data.inviteCode = inviteCode
    }
    if (!ifModify && !window.$userStatus.hasOwnProperty('users')) {
      data.verifyCode = verifyCode
    }
    if (claimSingerId) {
      data.claimSingerId = claimSingerId
      data.platform = platform
       if(window.sessionStorage.getItem('tempSubmitArr') && JSON.parse(window.sessionStorage.getItem('tempSubmitArr')).length != 0) data.thirdSingerProveFiles = JSON.parse(window.sessionStorage.getItem('tempSubmitArr'))
    }

    //如果是tme歌手的认领不能修改歌手信息
    if (platform === 4) {
      delete data.singerInfo.introduce
    }

    //authtype==0人脸识别，检测是否有人脸识别
    if(authType == 0) {
      if(realAuth == 2 && hasImg == 1) {
        //跳过
      } else if(localStorage.getItem("kg_faceid")) {
        //人脸识别回来，判断是否成功
        let kg_faceid = JSON.parse(localStorage.getItem("kg_faceid"))
        if(kg_faceid.errorMsg) {
          window.$Msg(window.decodeURIComponent(kg_faceid.errorMsg));
          return
        }
      } else {
        //未人脸识别
        window.$Msg('请完成人脸识别')
        setRealAuthTip({
          type: 'error',
          text: '点此处人脸识别'
        })
        return
      }
    }
    
    e.emit('loading', true)
    let submitReq = (localStorage.getItem("claimSingerId") ? localStorage.getItem("claimSingerId") : claimSingerId) ? 'upsertGotSingerEnterForm' : 'upsertEnterForm';
    //已实名自动填写身份证信息的情况
    if(autoFillRealInfo&&credentialType==0){
      if(submitReq == 'upsertGotSingerEnterForm'){////提交认领信息
        data.typ = 2;
      }else{
        data.typ = 1;
      }
      submitReq = 'autoFillClaimSubmit';
    }
    if(collegeEnter){
      window.pushBI({
        a: 24301,
        ft: '校园音乐人提交审核',
        r: '音乐人入驻',
        svar1: '移动端'
      });
    }
    console.log('submitdata', data)
    //console.log('submitReq', submitReq)
    //return
    window.$req(submitReq, data).then(res => {
      e.emit('loading', false)
      window.$Msg('提交成功')
      window.$toResultTag = true

      //处理以前的留存数据
      let localData = localStorage.getItem(`enter-musician-${window.$userInfo.userid}`)
      if(localData == 'original-creator') localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, 1)
      if(localData == 're-creator') localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, 2)
      window.$req('logType', {
        identity: localStorage.getItem(`enter-musician-${window.$userInfo.userid}`) || 0
      })
      
      window.$getUserStatus(({ status }) => {
        //原创音乐人入驻入口
        if(status === 16 && localStorage.getItem(`enter-musician-${window.$userInfo.userid}`) == '2'){
          setOriginal('2')
        }else{
          localStorage.getItem(`enter-musician-${window.$userInfo.userid}`) == null ?  setOriginal('0') : setOriginal(localStorage.getItem(`enter-musician-${window.$userInfo.userid}`))
        }
        //获取最近一次入驻作品审核不通过详情（状态19才能调用）
        if( status === 19 ){
          window.$req("auditResult",{platformAccountId: window.$userInfo.userid}).then(res=>{
            if(res.data && res.data.lastCommitType === 0){
              setOriginal('1')
            }else if(res.data && (res.data.lastCommitType === 1 || res.data.lastCommitType === 2)){
              setOriginal('2')
            }else if(res.data && res.data.lastCommitType === 3){
              setOriginal('3')
            }
          }).catch(err => {
            localStorage.getItem(`enter-musician-${window.$userInfo.userid}`) == null ?  setOriginal('0') : setOriginal(localStorage.getItem(`enter-musician-${window.$userInfo.userid}`))
          })
        }
        setFormatUserStatus(formStatusGroup[status])
        changeActiveIndex(3)
        LightMobileCall.mobileCall(710, { type: 0 })
        localStorage.removeItem('faceAuthPhoneFlag')
        localStorage.removeItem('claimSingerId')
        containRef && containRef.current && (containRef.current.scrollTop = 0)
      }, true)
    }).catch(rese => {
      e.emit('loading', false)
      if (rese.message) {
        let code = rese.code
        if (code === '040011') {
          setShowTipsDialog(true)
        } else if( code == '040359'){
          setAuthTip("您输入的身份证姓名和人脸识别身份证姓名不一致");
          setShowAuthFailDialog(true);
          setAuthBtn({
            1: false,
            2: false,
            3: true
          })
          //window.$Msg('该账号人脸识别失败，请选择上传身份证的认证方式进行入驻')
        } else if (code === '100002') {
          setBindSubTitle(`该手机（${localStorage.getItem("faceAuthPhoneFlag") ? data.personInfo.phone.split('*')[1] : phone}）已申请过入驻，直接验证绑定即可`)
          setBindInitPhone((localStorage.getItem("faceAuthPhoneFlag") ? data.personInfo.phone.split('*')[1] : phone))
          localStorage.removeItem('faceAuthPhoneFlag')
          localStorage.removeItem('claimSingerId')
          setBindDialogVisible(true)
        } else if (code === '040088') {//该证件号码已经被使用，但是没被检测到
          window.$req('checkNum', { idcardNum: credentialNum, type: credentialType }).then(res2 => {
            let check = res2.data.result
            if (!check) {
              let data = res2.data.bindPhone
              setCardBindPhone(data)
              setCheckNumInfo(res2.data.resultInfo)
              setIfCardBind(true)
            }
          });

          window.$Msg(rese.message)
        } else {
          window.$Msg(rese.message)
        }
      }
    })
  }

  //获取人脸识别信息
  function getFaceAuth() {
    e.emit('loading', true);
    window.$req('get_face_status').then(res => {
      e.emit('loading', false);
      //real_auth has_img
      //2 1 场景一：用户账号之前在别的业务走过人脸识别认证有认证图片，默认帮用户填写人脸识别实名信息后直接提交审核，或者选择上传身份证
      //2 0场景二：用户账号之前在别的业务走过人脸识别但无图片，则入驻时走上传手持身份证图片流程
      //real_auth 0或3 场景三：用户未实名认证过，走人脸识别流程或者上传身份证
      setRealAuth(res.real_auth);
      setHasImg(res.has_img);
      if( res.real_auth == 2 ){
        if(res.has_img == 0){
          setAuthType(1)//身份证验证
          setAuthTypeHidden(true)
        }else{
          setRealAuthTip({
            type: 'normal',
            text: '已实名认证'
          })
          setCanInput(false)
          setAuthType(0)//身份证验证
          setAuthTypeHidden(false)
          //已实名自动填写身份证及姓名
          if(res.idno && res.name){
            window.$req('autoCheckNum',{kugouid: window.$userInfo.userid}).then(json => {
              let check = json.data.result
              if (!check) {
                console.log('身份证已占用');
                setCanInput(true)
              }else{
                setCredentialNum(res.idno)
                setRealName(res.name)
                setAutoFillRealInfo(true)
              }
            }).catch(rese => {
              
            })
          }
        }
      }

      window.sessionStorage.setItem('real_auth', res.real_auth);
      window.sessionStorage.setItem('has_img', res.has_img)
    }).catch(err => {
      console.log('err', err)
      e.emit('loading', false);
      setRealAuth(0);
      setHasImg(0);
    })
  }

  // 获取初始化数据
  function getInitInfo() {
    //拿存储
    let saveForm = sessionStorage.getItem('saveForm')
    let info = props.match.params.info
    let realInfo = info ? JSON.parse(window.decodeURIComponent(info)) : null;
    setParams(realInfo)
    console.log('getInitInfo', realInfo);
    if (saveForm) {
      saveForm = JSON.parse(saveForm)
      setRealName(saveForm.realName)
      setPhone(saveForm.phone)
      setMail(saveForm.mail)
      setCredentialType(saveForm.credentialType)
      setCredentialNum(saveForm.credentialNum)
      setCredentialFrontPic(saveForm.credentialFrontPic)
      setCredentialBackPic(saveForm.credentialBackPic)
      setCredentialHandPic(saveForm.credentialHandPic)
      setName(saveForm.name)
      setPic(replaceHttpsImg(saveForm.pic))
      setType(saveForm.type)
      setArea(saveForm.area)
      setIdentity(saveForm.identity)
      setGenre(saveForm.genre)
      setIntroduce(saveForm.introduce)
      setEducationducationLevel(saveForm.educationLevel)
      setSchoolName(saveForm.schoolName)
      setSchoolType(saveForm.schoolType)
      setGraduationTime(saveForm.graduationTime)
      setCardCover(saveForm.cardCover)
      setCardContentPage(saveForm.cardContentPage)
      setCardRegisterPage(saveForm.cardRegisterPage)

      sessionStorage.removeItem('saveForm')
      if(info && realInfo.status === 70){
        statusOp(realInfo.status)
      }
      return;
    }

    if (info) {
      if (realInfo.id) {
        setClaimSingerId(realInfo.id)
        setPic(replaceHttpsImg(realInfo.pic))
        setName(textSub(realInfo.name, 20))
        setPlatform(realInfo.platform)

        //tme机构认领的
        if (~~realInfo.platform === 4) {
          setType(~~realInfo.type)
          setArea(~~realInfo.area)
          setIdentity(~~realInfo.identity)
          setGenre(~~realInfo.genre)
          setIntroduce(realInfo.introduce || '')
        }

      }
      //初始化状态
      statusOp(realInfo.status)
    }
  }

  //获取提交过的信息
  function getFormedInfo(ifGetSinger) {
    let reqName = ifGetSinger ? 'getGotSingerEnterFormInfo' : 'getEnterFormInfo'
    e.emit('loading', true)
    window.$req(reqName, {
      platformAccountId: window.$userInfo.userid,
    }).then(res => {
      e.emit('loading', false)
      let data = res.data
      let personInfo = data.personInfo
      let singerInfo = data.singerInfo

      if(data.thirdSingerProveFiles && data.thirdSingerProveFiles.length != 0) {
        window.sessionStorage.setItem('originScreenshotData', JSON.stringify(data.thirdSingerProveFiles))
      }

      ifGetSinger && setClaimSingerId(data.claimSingerId)
      ifGetSinger && setPlatform(data.platform)
      data.inviteCode && setInviteCode(data.inviteCode)
      // console.log('invite code ', data.inviteCode)

      setRealName(personInfo.name)
      setPhone(personInfo.phone)
      setMail(personInfo.mail)
      setCountry(personInfo.country)
      setCredentialType(personInfo.credentialType)
      setCredentialNum(personInfo.credentialNum)

      // 兼容新版上传url
      personInfo.credentialFrontPic && setCredentialFrontPic(personInfo.credentialFrontPic.replace('http://', 'https://'))
      personInfo.credentialBackPic && setCredentialBackPic(personInfo.credentialBackPic.replace('http://', 'https://'))
      personInfo.credentialHandPic && setCredentialHandPic(personInfo.credentialHandPic.replace('http://', 'https://'))

      setName(singerInfo.name)
      setPic(replaceHttpsImg(singerInfo.pic))
      setType(singerInfo.type)
      setArea(singerInfo.area)
      setIdentity(singerInfo.identity)
      setGenre(singerInfo.genre)
      setIntroduce(singerInfo.introduce)
    }).catch(err => {
      e.emit('loading', false)
      let msg = err.message
      if (msg) {
        if (err.code === '040328') {
          setIfOtherGet(true)
          setOtherGetDialog(true)
        } else {
          window.$Msg(err.message)
        }
      }
    })
  }

  function statusOp(status) {
    window.$getUserStatus(async (getStatusConfig) => {
      //以getUserInfo接口status为准
      //改成接口获取
      status = getStatusConfig.status
      //新入驻的不请求
      if(status != 0){
        //获取入驻类型，需要设置Process（是否为校园入驻）
        let logType = '';
        try {
          logType = await window.$req('getLogType')
          if(logType) {
            //处理以前的留存数据
            let localData = localStorage.getItem(`enter-musician-${window.$userInfo.userid}`)
            if(localData == 'original-creator') localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, 1)
            if(localData == 're-creator') localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, 2)
            setOriginal(logType.identity || localStorage.getItem(`enter-musician-${window.$userInfo.userid}`) || 0)
            logType.identity != 0 && localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, logType.identity)
            if(logType.identity == 4 || logType.identity == 5){
              setCollegeEnter(true)
            }else{
              setCollegeEnter(false)
            }
          } else {
            setOriginal('0')
          }
        } catch (error) {
          console.log('err', error)
          setOriginal('0')
        }
      }else{
        localStorage.getItem(`enter-musician-${window.$userInfo.userid}`) == null ?  setOriginal('0') : setOriginal(localStorage.getItem(`enter-musician-${window.$userInfo.userid}`))
      }
      //获取最近一次入驻作品审核不通过详情（状态19才能调用）
      if( status === 19 ){
        window.$req("auditResult",{platformAccountId: window.$userInfo.userid}).then(res=>{
          if(res.data && res.data.lastCommitType === 0){
            setOriginal('1')
            setWorkNoPassReason(res.data.lastAlbumFailReason)
          }else if(res.data && (res.data.lastCommitType === 1 || res.data.lastCommitType === 2)){
            setOriginal('2')
            res.data.lastCommitType === 1 && setWorkNoPassReason(res.data.lastCoverSongFailReason)
            res.data.lastCommitType === 2 && setWorkNoPassReason(res.data.lastCoverAlbumFailReason)
          }else if(res.data && res.data.lastCommitType === 3){
            setOriginal('3')
            setWorkNoPassReason(res.data.lastCqProductionFailReason)
          } else {
            localStorage.getItem(`enter-musician-${window.$userInfo.userid}`) == null ?  setOriginal('0') : setOriginal(localStorage.getItem(`enter-musician-${window.$userInfo.userid}`))
          }
          console.log('original', original)
        }).catch(err => {
          localStorage.getItem(`enter-musician-${window.$userInfo.userid}`) == null ?  setOriginal('0') : setOriginal(localStorage.getItem(`enter-musician-${window.$userInfo.userid}`))
        })
      }
      if(status === 70 || status === 71 || status === 72){
        setSettledLibrettist(true)
        status === 70 && setMbtnText("去补充")
        if(status === 70){
          showTips('您需完善歌手资料，审核通过后即在酷狗客户端展示您歌手页')
          setNoPassReason('您需完善歌手资料，审核通过后即在酷狗客户端展示您歌手页')
        }
      }
      // status分状态
      if (getStatusConfig.delete) {
        setNoPassReason(getStatusConfig.users && getStatusConfig.users[0] && getStatusConfig.users[0].lastAuditFailureReason || '该账号已被永久注销')
        // setUserStatus(900)
        setFormatUserStatus(formStatusGroup[900])
        changeActiveIndex(3)
        LightMobileCall.mobileCall(710, { type: 0 })
        return;
      } else if (getStatusConfig.black) {
        setNoPassReason(getStatusConfig.blackReason)
        // setUserStatus(901)
        setFormatUserStatus(formStatusGroup[901])
        changeActiveIndex(3)
        LightMobileCall.mobileCall(710, { type: 0 })
        return;
      } else if (~[12, 14, 17, 22, 24, 72].indexOf(status)) {
        //如果是不通过状态
        // 先看是否有入驻歌手的角色
        let singerItem;
        if (Array.isArray(getStatusConfig.users)) {
          singerItem = getStatusConfig.users.find(ele => ele.role === 1)
        }
        if (singerItem) {
          setNoPassReason(singerItem.lastAuditFailureReason)
        }
      }
      // setUserStatus(status)
      setFormatUserStatus(formStatusGroup[status])
      //如果有状态直接显示最后一步
      if (formStatusGroup[status] && !ifModify) {
        changeActiveIndex(3)
        LightMobileCall.mobileCall(710, { type: 0 })
      }
      // 审核不通过可修改的话
      let canAuditNormalStatus = [17, 72]
      let canAuditGetSingerStatus = [22, 24]
      if( ~canAuditNormalStatus.indexOf(status) || ~canAuditGetSingerStatus.indexOf(status) ){
        window.$req('studentInfo', {
          platformAccountId: window.$userInfo.userid,
          platformIdType: 2
        }).then(res => {
          if(res && res.code == '0'){
            if ( res.data && res.data.status == 'REJECT' ){
              setStuNoPassReason(res.data.result)
            }
            if ( res.data && res.data.id ){
              setCollegeEnter(true)
              //验证返回数据是否匹配
              if(~['juniorCollege', 'undergraduate', 'graduateStudent', 'doctor', 'other'].indexOf(res.data.educationLevel)){
                setEducationducationLevel(res.data.educationLevel)
              }
              if(~['Domestic', 'HkMcTw', 'Foreign'].indexOf(res.data.schoolType)){
                setSchoolType(res.data.schoolType)
              }
              setSchoolName(res.data.schoolName)
              //返回的时间是毫秒，上报的是yyyy-MM-dd，需要处理一下
              if(typeof(res.data.graduationTime) == 'number'){
                setGraduationTime(formatDate(new Date(res.data.graduationTime)))
              }
              setCardCover(res.data.cardCover.replace('http://', 'https://'))
              setCardContentPage(res.data.cardContentPage.replace('http://', 'https://'))
              setCardRegisterPage(res.data.cardRegisterPage.replace('http://', 'https://'))
            }else{
              setCollegeEnter(false)
            }
          }
          
          if (~canAuditNormalStatus.indexOf(status)) {
            getFormedInfo()
          } else if (~canAuditGetSingerStatus.indexOf(status)) {
            getFormedInfo(true)
          }
        })
      }
    })
  }

  //处理绑定结果
  function resultOp(status, info) {
    setInfo(info)
    setResultStatus(status)
    setBindDialogVisible(false)
    setResultDialogVisible(true)
  }

  useEffect(() => {
    //处理正在裁剪点击返回的情况
    window.pickPicReturn = function(){
      if(window.uploadingFlag && window.uploadEle.cropper && window.uploadEle.cropper){
        window.uploadingFlag = false
        window.uploadEle.destroy()
      }else{
        // 修复回到首页之后无法退出webview的问题
        if(!window.location.hash || window.location.hash === '#/') {
          console.debug('mobileCall 247');
          LightMobileCall.mobileCall(247, {
            count: 1,
          });
          return;
        }
        window.history.back()
      }
    }
    LightMobileCall.mobileCall(710, { type: 3, cb: "pickPicReturn" })
    //LightMobileCall.mobileCall(710, { type: 1 })
    if(LightMobileCall.isIOS){
      LightMobileCall.mobileCall(602, { title: '酷狗音乐开放平台' })
    }else{
      LightMobileCall.mobileCall(166, { title: '酷狗音乐开放平台' })
    }

    //歌手页认领歌手入口直接进入的 或 音乐人后台进入的
    if( (getQueryString('claimSinger') && getQueryString('singername') && getQueryString('singerid')) || getQueryString('settleFromBackend') ){
      //左上角点击退出
      LightMobileCall.mobileCall(710, { type: 0 })
    }

    //如果已有申请记录，则直接显示结果
    /* if (window.$userStatus) {
      let status = window.$userStatus.status
      statusOp(status)
    } else {
      window.$getUserStatus(({ status }) => {
        statusOp(status)
      })
    } */

    if (window.toBind) {
      setBindSubTitle('')
      setBindInitPhone('')
      setBindDialogVisible(true)
    }

    //init,如果是人脸识别功能的新打开页则不请求
    let _href = window.location.href.indexOf('FaceAuBack') > -1 ? window.decodeURIComponent(window.location.href) : ''
    let temp = _href.slice(_href.indexOf('FaceAuBack') + 'FaceAuBack'.length + 1, _href.indexOf('&')).replace('"{','{').replace('}"','}')
    let info = temp ? JSON.parse(temp) : {};

    !info.faceAuthBack && getInitInfo()
    //inviteCode
    !info.faceAuthBack && getInviteCode()
    //获取人脸识别信息
    getFaceAuth()

    let $base = window.$baseConf
    if (!$base || !Object.keys($base).length) {
      (activeIndex === 0) && getBaseConfig(() => {
        setGotConfig(window.$baseConf)
      })
    } else {
      setGotConfig($base)
    }
    
    //安卓弹出键盘设置（270）http://doc.kugou.net/showdoc-master/web/#/5?page_id=578
    LightMobileCall.mobileCall(270, {type: 1});
  }, [])

  useEffect(() => {
    LightMobileCall.KgWebMobileCall("KgWebMobileCall.imeChanged", function(res){
      var resObj = typeof res === 'string' ? JSON.parse(res) : res
      if (resObj.height > 0 && !LightMobileCall.isIOS) {
        //当软键盘弹出，在这里面操作
        if(activeIndex == 2){
          bottomTip && bottomTip.current && (bottomTip.current.style.paddingBottom = '5rem')
          setTimeout(() => {
            containRef && containRef.current && (containRef.current.scrollTop = 230)
          }, 500)
        }
        if( activeIndex == 0 && !LightMobileCall.isIOS){//简介的输入
          if(document.activeElement.classList.value == "intro-text"){
            introInput()
          }
        }
      } else {
        if( activeIndex == 0 && !LightMobileCall.isIOS){//简介的输入
          introBlur()
        }
        if(activeIndex == 2 && (window.inputFocusNow == '验证码' || window.inputFocusNow == '邀请码')){
          containRef && containRef.current && (containRef.current.scrollTop = 0) 
          bottomTip && bottomTip.current && (bottomTip.current.style.paddingBottom = '0')
        }
      }
    })
  }, [activeIndex])

  //处理绑定结果
  function controlSetBindDialogVisible(visible) {
    setResultDialogVisible(visible)
  }

  //简介弹起键盘
  function introInput() {
    pageBottom && pageBottom.current && (pageBottom.current.style.marginBottom = '5rem')
    containRef && containRef.current && (containRef.current.scrollTop = 500)
  }

  function introBlur(){
    pageBottom && pageBottom.current && (pageBottom.current.style.marginBottom = '0')
    containRef && containRef.current && (containRef.current.scrollTop = 0)
  }

  function changeHeight(){
    if(/iphone/gi.test(navigator.userAgent) && (window.screen.height == 812 && window.screen.width == 375)) {
      return {"height": "calc(100% - 2.55rem)"}
    } else if (/iphone/gi.test(navigator.userAgent) && (window.screen.height == 896 && window.screen.width == 414)) {
      return {"height": "calc(100% - 2.95rem)"}
    }
  }

  /* 发布原创作品，跳转微信小程序 */
  function toUploadSong(){
    localStorage.setItem(`to-upload-song-${window.$userInfo.userid}`, 'go-wx-minigram')
    console.log('跳转');
    setToUploadSongDialog(false)
    window.pushBI({
      a: 23276,
      ft: '确认跳转按钮',
      r: '原创音乐人入驻'
    });
    setTimeout(() => {
      //if(LightMobileCall.isIOS){
        //ios监听不到回到页面
        setHasUploadSongDialog(true)
      //}
    }, 2500);
    console.log('path', `/pages/user/platform?platform=kugou&platformAppid=${window.$userInfo.appid}&platformToken=${window.$userInfo.token}&platformUserId=${window.$userInfo.userid}&action=origin`)
    LightMobileCall.mobileCall(269, {
      type: 0,
      //正式
      id: 'gh_04651568847b',
      ver: 0,
      //测试
      // id: 'gh_60da8a7ebd2f',
      // ver: 2,
      url: '',
      path: `/pages/user/platform?platform=kugou&platformAppid=${window.$userInfo.appid}&platformToken=${window.$userInfo.token}&platformUserId=${window.$userInfo.userid}&action=origin`,
    });
  }

  /* 发布翻唱作品，跳转微信小程序 */
  function toCoverUploadSong(){
    localStorage.setItem(`to-upload-song-${window.$userInfo.userid}`, 'go-wx-minigram')
    console.log('跳转');
    setToCoverUploadSongDialog(false)
    window.pushBI({
      a: 23276,
      ft: '确认跳转按钮',
      r: '翻唱音乐人入驻'
    });
    setTimeout(() => {
      //if(LightMobileCall.isIOS){
        //ios监听不到回到页面
        setHasCoverUploadSongDialog(true)
      //}
    }, 2500);
    console.log('path', `/pages/user/platform?platform=kugou&platformAppid=${window.$userInfo.appid}&platformToken=${window.$userInfo.token}&platformUserId=${window.$userInfo.userid}&action=cover`)
    LightMobileCall.mobileCall(269, {
      type: 0,
      //正式
      id: 'gh_04651568847b',
      ver: 0,
      //测试
      // id: 'gh_60da8a7ebd2f',
      // ver: 2,
      url: '',
      path: `/pages/user/platform?platform=kugou&platformAppid=${window.$userInfo.appid}&platformToken=${window.$userInfo.token}&platformUserId=${window.$userInfo.userid}&action=cover`,
    });
  }

  function refreshPageFn(){
    console.log('刷新');
    setHasUploadSongDialog(false)
    setHasCoverUploadSongDialog(false)
    refreshPage()
  }

  return (<div className="Enter">
    {/* 人脸识别跳转回来 */}
    {faceAuthBack ? <div className="faceAuthBackPage"></div>:<div className="none"></div>}
    {/* activeIndex:
    0: 歌手信息
    1: 校园信息
    2: 实名认证
    3: 认证审核 */}
    <div className={`enterContainer ${activeIndex === 3 ?'enterResultContainer':''}`} ref={containRef}>
      {(activeIndex !== 3 && !ifModify && !window.$toResultTag) && !window.$noBindDialog && !settledLibrettist && <TopEnterTips tab={() => {
        window.pushBI({
          a: 21393,
          ft: '音乐人入驻',
          r: '手机页立即绑定'
        });
        setBindSubTitle('')
        setBindInitPhone('')
        setBindDialogVisible(true)
      }} />}
      
      {!settledLibrettist && <Process descs={collegeEnter ? ['歌手信息', '学生信息', '实名认证'] : ['歌手信息', '实名认证']} activeIndex={activeIndex} />}

      {!!Object.keys(gotConfig).length && activeIndex < 3 && <div style={{ padding: '0.2rem' }}>
        {/* 歌手信息 */}
        <div style={{ display: activeIndex === 0 ? 'block' : 'none' }}>
          <Form fields={fields1} dict={gotConfig}/>
        </div>

        {/* 学生信息 */}
        <div style={{ display: activeIndex === 1 ? 'block' : 'none' }}>
          <Form fields={fields2} dict={gotConfig} />
        </div>

        {/* 实名认证 */}
        <div style={{ display: activeIndex === 2 ? 'block' : 'none' }}>
          <Form fields={fields3} dict={gotConfig} containRef={containRef} 
          showIDCard={showIDCard} 
          setShowIDCard={setShowIDCard} 
          authTypeHidden={authTypeHidden} 
          setAuthType={setAuthType} 
          setShowAuthFailDialog={setShowAuthFailDialog} 
          setAuthTip={setAuthTip} 
          setAuthBtn={setAuthBtn} 
          openFaceAuth={openFaceAuth} 
          realAuthTip={realAuthTip} 
          setRealAuthTip={realAuthTip} 
          authType={authType} 
          showSelectTip={showSelectTip} 
          credentialNum={credentialNum} 
          setCredentialType={setCredentialType} 
          credentialType={credentialType} 
          selectType={selectType} 
          setSelectType={setSelectType} 
          canInput={canInput} 
          setCanInput={setCanInput}
          autoFillRealInfo={autoFillRealInfo}
          setAutoFillRealInfo={setAutoFillRealInfo}
          setCheckNumInfo={setCheckNumInfo}
          params={params}
          />
          <div ref={bottomTip} style={{ height: '1.1rem', lineHeight:'1.1rem',margin: '0 auto 1.1rem',color: '#888',fontSize: '0.24rem',textAlign: 'center' }}>您的认证信息将同步至腾讯音乐娱乐集团进行审核</div>
        </div>
      </div>}

      {activeIndex === 0 &&
        <Fragment> <section className={"agreeLine" + (agree ? ' active' : '')} onClick={() => setAgree(!agree)}>
          同意<span onClick={toCheckAgreeDetail}>《腾讯音乐开放平台服务协议》</span>所有条款
          </section>
          <div ref={pageBottom} style={{ height: '1.5rem' }}></div>
        </Fragment>}

      {/* 认证审核页 */}
      {activeIndex === 3 && <section className={`enterResult ${settledLibrettist?'nProgressH':''}` + (activeIndex === 3 || ifModify ? ' moreH' : '')}>
        <div className="top"  style={changeHeight()}>
          {!!~['noWork'].indexOf(formatUserStatus) ? <Fragment>
            <section className={`toPc ${original != '3' ? 'origin':''}`}>
              {original == '3' && <img src="https://webimg.kgimg.com/e635571697b5f5d0a58fc5a9b4c7378d.png" />}
              {original != '3' && <img className="bird" src="https://webimg.kgimg.com/1348db43265156c3a3b568c980802dd2.png" />}
              <p className="content">还差最后一步！</p>
            </section> 
            
            {(original == '0' || original == '1' || original == '4') && <Fragment>
              <p className="tip tip1">上传作品，审核通过后即可入驻</p>
              <Button text="立即上传" fn={()=>{setToUploadSongDialog(true)}}/>
              <p className="upload-guide origin-ug" onClick={() => {history.go('/guide')}}>您也可在电脑端上传作品></p>
            </Fragment>}
            {(original == '2' || original == '5') && <Fragment>
              <p className="tip tip1">上传作品，审核通过后即可入驻</p>
              <Button text="立即上传" fn={()=>{setToCoverUploadSongDialog(true)}}/>
              <p className="upload-guide origin-ug" onClick={() => {history.go('/guide')}}>您也可在电脑端上传作品></p>
            </Fragment>}
            {original == '3' && <Fragment>
              <p className="fiveIcon">
                请在电脑端登录 ( musician.kugou.com ) 上传词曲作品即可完成入驻，入驻后即可拥有酷狗歌手页
              </p>
              {/* <p className="upload-guide" onClick={() => {history.go('/guide')}}>怎么上传作品？</p> */}
            </Fragment>}
            {(original != '0' && !original) && <Fragment>
              <p className="tip tip1">上传作品，审核通过后即可入驻</p>
              <Button text="立即上传" fn={()=>{setToUploadSongDialog(true)}}/>
              <p className="upload-guide origin-ug" onClick={() => {history.go('/guide')}}>您也可在电脑端上传作品></p>
            </Fragment>}
          </Fragment> :
          <section className={"good" + (~['workInAudit','getInAudit','cqInAudit'].indexOf(formatUserStatus) ? '' : ' no')}></section>}

          <section className="mainInfo">
            {/* {!!~['noWork'].indexOf(formatUserStatus) && <p>太棒了，你的基本信息申请已收到</p>} */}
            {/* {!!~['noWork'].indexOf(formatUserStatus) && <p>离入驻成功就差一步啦！</p>} */}
            {!!~['workInAudit','cqInAudit'].indexOf(formatUserStatus) && <p>资料提交成功，管理员正在审核中！</p>}
            {!!~['getInAudit'].indexOf(formatUserStatus) && <p>您的认领申请正在审核中！</p>}
            {!!~['getFail'].indexOf(formatUserStatus) && <p>您的认领审核不通过，请修改信息重新认领！</p>}
            {!!~['getError'].indexOf(formatUserStatus) && <p>您的认领入驻失败，请修改信息重新认领！</p>}
            {!!~['delete'].indexOf(formatUserStatus) && <p>您的账号已被注销</p>}
            {!!~['black'].indexOf(formatUserStatus) && <p>您的账号已被冻结</p>}
          </section>
          <section className="desc">
            {!!~['black'].indexOf(formatUserStatus) && <p><span dangerouslySetInnerHTML={{ __html: noPassReason }}></span></p>}
            {!!~['black'].indexOf(formatUserStatus) && <p className="black" style={{ marginTop: '.2rem' }}>1、冻结后，音乐人在开放平台只能查询，不能进行其他操作</p>}
            {!!~['black'].indexOf(formatUserStatus) && <p className="black">2、平台将不显示“酷狗音乐人”标识</p>}
            {!!~['black'].indexOf(formatUserStatus) && <p className="black">3、音乐人审核的申请，都将被拒绝</p>}
            {!!~['delete'].indexOf(formatUserStatus) && <p>{noPassReason}</p>}
            {!!~['workInAudit', 'getInAudit','cqInAudit'].indexOf(formatUserStatus) && '请耐心等待，您的申请将尽快审核~'}

            {!!~['failWork'].indexOf(formatUserStatus) && <Fragment>
              {original == '0' && <Fragment>
                <p className="failWork-title">审核未通过</p>
                <p style={{marginBottom: "10px"}}>{workNoPassReason ? <span dangerouslySetInnerHTML={{ __html: workNoPassReason }}></span> : '您的作品审核未通过，请修改作品后重新提交审核'}</p>
                <Button text="去修改作品" fn={()=>{setToUploadSongDialog(true)}}/>
                <p className="upload-guide origin-ug" onClick={() => {history.go('/guide')}}>您可以在电脑端修改作品></p>
              </Fragment>}
              {original == '1' && <Fragment>
                <p className="failWork-title">审核未通过</p>
                <p style={{marginBottom: "10px"}}>{workNoPassReason ? <span dangerouslySetInnerHTML={{ __html: workNoPassReason }}></span> : '您的作品审核未通过，请修改作品后重新提交审核'}</p>
                <Button text="去修改作品" fn={()=>{setToUploadSongDialog(true)}}/>
                <p className="upload-guide origin-ug" onClick={() => {history.go('/guide')}}>您可以在电脑端修改作品></p>
              </Fragment>} 
              {original == '2' && <Fragment>
                <p className="failWork-title">审核未通过</p>
                <p style={{marginBottom: "10px"}}>{workNoPassReason ? <span dangerouslySetInnerHTML={{ __html: workNoPassReason }}></span> : '您的作品审核未通过，请修改作品后重新提交审核'}</p>
                <Button text="去修改作品" fn={()=>{setToCoverUploadSongDialog(true)}}/>
                <p className="upload-guide origin-ug" onClick={() => {history.go('/guide')}}>您可以在电脑端修改作品></p>
              </Fragment>}
              {original == '3' && <Fragment>
                <p>您的词曲作品审核未通过，请移步酷狗音乐人官网</p>
                <p>（musician.kugou.com）修改作品后重新提交审核</p>
              </Fragment>}
              {(original != '0' && original != '1' && original != '2' && original != '3') && <Fragment>
                <p className="failWork-title">审核未通过</p>
                <p style={{marginBottom: "10px"}}>{workNoPassReason ? <span dangerouslySetInnerHTML={{ __html: workNoPassReason }}></span> : '您的作品审核未通过，请修改作品后重新提交审核'}</p>
                <Button text="去修改作品" fn={()=>{setToUploadSongDialog(true)}}/>
                <p className="upload-guide origin-ug" onClick={() => {history.go('/guide')}}>您可以在电脑端修改作品></p>
              </Fragment>}
            </Fragment>}

            {!!~['failGo','cqSupply','cqFail'].indexOf(formatUserStatus) && <Fragment>
              <p>{noPassReason ? <span dangerouslySetInnerHTML={{ __html: noPassReason }}></span> : '审核未通过，请移步酷狗音乐人官网'}</p>
              {!noPassReason && <p>（musician.kugou.com）修改作品后重新提交审核</p>}
            </Fragment>}

            {!!~['fail'].indexOf(formatUserStatus) && <p style={{marginBottom: '.1rem'}}>审核未通过</p>}
            {!!~['fail'].indexOf(formatUserStatus) && <div><div dangerouslySetInnerHTML={{ __html: noPassReason }}></div>{stuNoPassReason ? `学生信息：${stuNoPassReason}`:''}</div>}
            {!!~['fail'].indexOf(formatUserStatus) && <p style={{marginTop: '.1rem'}}>请修改歌手信息{collegeEnter?'/学生信息':''}/实名信息后重新提交申请</p>}
            {!!~['getFail'].indexOf(formatUserStatus) && <p><span dangerouslySetInnerHTML={{ __html: noPassReason }}></span></p>}
          </section>

          {!!~['fail', 'failGo', 'getFail','cqSupply','cqFail'].indexOf(formatUserStatus) && <section className="toModify">
            <Button text={mbtnText} fn={() => {
              setIfModify(true);
              if (ifOtherGet) {
                setOtherGetDialog(true)
              } else {
                changeActiveIndex(0);
              }
            }} />
          </section>}
        </div>
      </section>}
      {activeIndex === 3 && <div className="tips">
        <div className="seperate"></div>
        <FollowTips big />
      </div>}
    </div>

    {activeIndex == 0 && <div className="FixBottomBtn container">
      <Button text={settledLibrettist ? '提交审核':'下一步'} fn={()=>{
        if(settledLibrettist){
          if (!checkField()) return;
          sendLibrettistAudit()
        }else{
          if (!checkField()) return;
          if( collegeEnter ){
            changeActiveIndex(activeIndex + 1)
          }else{
            changeActiveIndex(2)
          }
          containRef && containRef.current && (containRef.current.scrollTop = 0)
        }
      }} />
    </div>}

    {activeIndex == 1 && <div className="FixBottomBtn container">
      <div className="dbtn" onClick={() => {
        changeActiveIndex(activeIndex - 1)
      }}>上一步</div>
      <div className="dbtn" onClick={()=>{
        if (!checkField()) return;
        changeActiveIndex(activeIndex + 1)
      }}>下一步</div>
    </div>}

    {activeIndex == 2 && <div className="FixBottomBtn container">
      <div className="dbtn" onClick={() => {
        if( collegeEnter ){
          changeActiveIndex(activeIndex - 1)
        }else{
          changeActiveIndex(0)
        }
      }}>上一步</div>
      <div className="dbtn" onClick={()=>{
        if (!checkField()) return;
        sendAudit()
      }}>提交审核</div>
    </div>}

    <AppealDialog visible={appealDialogVisible} setVisible={setAppealDialogVisible} />
    <HasBeenBindDialog visible={beenBindDialogVisible} setVisible={setBeenBindDialogVisible} />
    <TencentDialog toAppeal={() => { setBindDialogVisible(false); setAppealDialogVisible(true) }} initPhone={bindInitPhone}
      subTitle={bindSubTitle} visible={bindDialogVisible} setVisible={setBindDialogVisible} result={resultOp} saveForm={localSaveForm}/>
    <BindResultDialog visible={resultDialogVisible} setVisible={controlSetBindDialogVisible} status={resultStatus} info={info} />
    
    <ConfirmDialog content="即将离开酷狗客户端，前往小程序上传原创作品" fn={toUploadSong} visible={toUploadSongDialog} setVisible={setToUploadSongDialog} />

    <ConfirmDialog content="你是否已经上传作品" closeText="未上传" confirmText="已上传" closeCb={refreshPageFn} fn={refreshPageFn} visible={hasUploadSongDialog} setVisible={setHasUploadSongDialog} />

    <ConfirmDialog content="即将离开酷狗客户端，前往小程序上传翻唱作品" fn={toCoverUploadSong} visible={toCoverUploadSongDialog} setVisible={setToCoverUploadSongDialog} />

    <ConfirmDialog content="你是否已经上传作品" closeText="未上传" confirmText="已上传" closeCb={refreshPageFn} fn={refreshPageFn} visible={hasCoverUploadSongDialog} setVisible={setHasCoverUploadSongDialog} />

    <Dialog title="提示" visible={showTipsDialog} setVisible={setShowTipsDialog} btns={[{ text: '知道了', fn: () => setShowTipsDialog(false) }]}>
      <div className="EnterWhatTipsContent">
        <p>音乐人已经被认领。</p>
        <p onClick={()=>{
          openKf()
        }}>如您有任何疑问，可咨询酷狗在线客服：<span className="blue">点击联系</span></p>
      </div>
    </Dialog>

    <Dialog title="提示" visible={otherGetDialog} setVisible={setOtherGetDialog} btns={[{ text: '知道了', fn: () => setOtherGetDialog(false) }]}>
      <div className="EnterWhatTipsContent">
        <p>您的音乐人认领审核未通过，请移步至酷狗音乐人网页（musician.kugou.com）修改认领信息后重新提交</p>
      </div>
    </Dialog>

    <Dialog title="提示" visible={showInviteCodeTipsDialog} setVisible={setShowInviteCodeTipsDialog} btns={[{ text: '知道了', fn: () => setShowInviteCodeTipsDialog(false) }]}>
      <div className="EnterWhatTipsContent">
        <p style={{ paddingBottom: '.3rem' }}>填写好友发出的邀请码，若您成功入驻，<span style={{"color":"red"}}>您和好友都可获得5000酷豆</span></p>
        <p style={{ paddingBottom: '.3rem' }}>如何邀请<br/>已入驻的音乐人-音乐人后台-任务中心-邀请音乐人入驻</p>
      </div>
    </Dialog>

    <Dialog title="提示" visible={showIdCardTipsDialog} setVisible={setShowIdCardTipsDialog} btns={[{ text: '知道了', fn: () => setShowIdCardTipsDialog(false) }]}>
      <div className="EnterWhatTipsContent">
        <img style={{ width:'100%', margin:'-0.2rem auto 0.2rem' }} src={credentialType == 4 ? "https://webimg.kgimg.com/3fc2ac496fbafde5f541b611e32c0858.png" : "https://imgessl.kugou.com/h5_pic/20200413113931204147.jpg"} alt="示例图"/>
        {credentialType != 4 && <p style={{ paddingBottom: '.2rem' }}>1）手持证件照必须露出上半身，且人脸和文字必须清晰可鉴定</p>}
        {credentialType != 4 && <p style={{ paddingBottom: '.3rem' }}>2）证件正反面照片避免反光、不得有遮挡</p>}
        {credentialType == 4 && <p style={{ paddingBottom: '.3rem','textAlign': 'center' }}>上传的图片需完整露出边框，不得有遮挡</p>}
      </div>
    </Dialog>

    <Dialog title="提示" visible={showTipsDialog} setVisible={setShowTipsDialog} btns={btnFn} hideClose={hideClose}>
      <div className="centerText" dangerouslySetInnerHTML={{ __html: tipsContent }}></div>
    </Dialog>

    <Dialog title={authBtn[3]?"验证失败":"认证提示"} visible={showAuthFailDialog} setVisible={setShowAuthFailDialog}>
      <div className="centerText auth-fail-tip" dangerouslySetInnerHTML={{ __html: authTip }}></div>
      {authBtn[1]&&<Button text="重试人脸识别认证" fn={() => {
        setShowAuthFailDialog(false)
        if (!checkField()) return;
        sendAudit();
      }}/>}
      {authBtn[2]&&<div className="auth-contine-tip" onClick={()=>{
        setShowAuthFailDialog(false)
        setCredentialType(0)
        setAuthType(1)
        setAutoFillRealInfo(false)
      }}>改用上传身份证照片认证</div>}
      {authBtn[3]&&<div className="Button auth-btn" onClick={() => {
        setShowAuthFailDialog(false)
        setCredentialType(0)
        setAuthType(1)
        setAutoFillRealInfo(false)
      }}>改用上传身份证照片认证</div>}
       {authBtn[4]&&<div className="Button auth-btn" onClick={() => {
        setShowAuthFailDialog(false)
        setCredentialType(0)
        setAutoFillRealInfo(false)
      }}>使用身份证认证</div>}
    </Dialog>

    <Dialog 
      title={title||"提示"} 
      titleStyle={{margin:0,padding:"0.4rem 0 0.3rem"}} 
      visible={dialogFromUrl} 
      setVisible={setDialogFromUrl} 
      btns={window.LC.isInClient()?[{ text: '知道了', fn: () => setDialogFromUrl(false) }]:[{ text: '打开酷狗查看', fn: () => {setDialogFromUrl(false);openKg()} }]}>
      <div className={left ? "urlTip left" : "urlTip"}>
        <div dangerouslySetInnerHTML={{__html: dialogFromUrlCon}}></div>
      </div>
    </Dialog>

    <FaceRecognition 
      name={realName} 
      idNum={credentialNum}
      jumpUrl={jumpUrl}  
      openRecognite={openRecognite}  
      reqId={''} 
      faceAuthBack={faceAuthBack}
      showTips={showTips} 
      setShowTipsDialog={setShowTipsDialog}
      showIDCardEnter = {showIDCardEnter}
    ></FaceRecognition>

  </div>)
}